import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { differenceInSeconds } from "date-fns";
import { css } from "@emotion/react";

import { IProduct } from "@src/hooks/stateLand/useStateLand";
import timer from "@src/assets/stateLand/sandglassIcon.json";
import recommend from "@src/assets/subs/recommend.png";
import convertNumberToKorean, { convertNumberToKoreanWithThousand } from "@src/util/convertNumToKorean";
import { Radio } from "@mui/material";
import discount40 from "@src/assets/subscription/springPromotion40.png";

import redCurlyArrow from "@src/assets/subscription/product_arrow.svg";

interface Props {
    product: IProduct;
    selectedProduct?: IProduct;
    onClickProduct: (val: IProduct) => void;
    type?: number;
    selectedProductList?: IProduct[] | any[];
}

const NewStateLandProduct: React.FC<Props> = ({ product, selectedProductList, onClickProduct, selectedProduct, type = 3 }) => {
    const [now, setNow] = useState<any>(new Date());

    const hasMonthlyInstallmentEvent = product.isEvent && product.extraData?.installment! > 0;

    const getEventDuration = (now: any) => {
        const diffTime = differenceInSeconds(new Date(product.showEndAt).getTime(), now.getTime());
        const secound = diffTime % 60;
        const min = ((diffTime - secound) % 3600) / 60;
        const hours = ((diffTime - min * 60 - secound) % 86400) / 3600;
        const day = ((diffTime - min * 60 - secound - hours * 3600) % 31536000) / 86400;
        const formatTime = `${day}일 ${hours}시간 ${min}분 ${secound}초`;

        return formatTime;
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            setNow(new Date());
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const isVVIP = product?.name.includes("VVIP") ? true : false;

    return (
        <>
            <div
                css={productCardBoxStyle(
                    selectedProductList?.some((data) => data.code == product.code) ?? false,
                    product?.isEvent,
                )}
                onClick={() => onClickProduct(product)}
            >
                {/* <PremiumSpringPromotionTimeTooltip top="-24px" left="75%" /> */}
                {product.recommend === 1 && <img src={recommend} alt="" className="recommend" width={45} />}
                {/* {Date.now() < 1710687600000 && Date.now() >= 1708959600000 && (
                    <div className="eventText">
                        <img src={eventText} alt="eventText" width={88} />
                        <div css={lastDiscountTextStyle}>{product?.priceDiscountDisplay1}</div>
                    </div>
                )} */}
                <div css={cardContentsStyle}>
                    <div css={titleWrapStyle}>
                        <Radio
                            checked={true}
                            onChange={() => {}}
                            sx={{
                                width: 16,
                                height: 16,
                                color:
                                    selectedProductList &&
                                    selectedProductList.some((data: IProduct) => data.code === product?.code)
                                        ? "#2275EE !important"
                                        : "#C9C9C9 !important",
                            }}
                        />
                        <div css={titleStyle}>
                            {product.name}
                            <span className="priceDiscountDisplay1">{product.priceDiscountDisplay1}</span>
                        </div>
                    </div>
                    <div css={bottomContent}>
                        <div className="stickerContainer" style={{ flexDirection: "row" }}>
                            <span className="discountRedText" style={{ marginLeft: "100px" }}>
                                {isVVIP ? "20% 할인" : "30% 할인"}
                            </span>
                        </div>

                        <div css={priceWrapStyle}>
                            {product?.term1DiscountedPrice !== product.price && (
                                <p css={priceInfoStyle}>{convertNumberToKorean(product.price)}원</p>
                            )}
                            <div css={term2PriceStyle}>
                                <p css={discountTextStyle}>기존</p>
                                <p css={discountPriceTextStyle}>{isVVIP ? "515,000원" : "387,000원"}</p>
                            </div>
                            <div css={term1PriceStyle(hasMonthlyInstallmentEvent)}>
                                <div css={lastDiscountTextStyle}>{isVVIP ? "-20%" : "-30%"}</div>
                                <div>
                                    <span className="priceText">
                                        {convertNumberToKoreanWithThousand(product?.term1DiscountedPrice)}원
                                    </span>
                                </div>
                            </div>

                            <div css={monthlyStyle}>
                                <img src={redCurlyArrow} alt="curlyArrow" width={30} />
                                <span>{isVVIP ? "한 달에 약 34,000원!!" : "한 달에 약 23,000원!!"}</span>
                            </div>

                            {hasMonthlyInstallmentEvent && (
                                <div css={monthlyInstallmentPriceStyle}>
                                    3개월 할부 시 월{" "}
                                    {product.term1DiscountedPrice > 0
                                        ? convertNumberToKoreanWithThousand(Math.floor(product.term1DiscountedPrice / 3))
                                              .split("")
                                              .reduce((prev, current) => (prev.includes("천") ? prev : prev + current))
                                        : "0"}
                                    원
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {product.isEvent && now >= new Date(product.showStartAt) && now <= new Date(product.showEndAt) && (
                    <div css={eventBoxStyle}>
                        <Lottie className="lottie" animationData={timer} />
                        {getEventDuration(now)}
                    </div>
                )}
                {/* <div css={timerStyle}>
                    <PremiumSpringPromotionTimer />
                </div> */}
            </div>
        </>
    );
};

export default NewStateLandProduct;

const productCardBoxStyle = (active: boolean, isEvent: boolean) => css`
    border-radius: 14px;
    border: ${active ? "2px solid #2275EE" : "1px solid #dadada"};
    background-color: #ffffff;
    box-shadow: 2px 2px 6px 0px rgba(4, 0, 14, 0.14);
    display: flex;
    flex-direction: column;
    gap: 4px;

    margin: 14px 0;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    & > .recommend {
        position: absolute;
        transform: translate(-50%, -50%);
        top: -1px;
    }
    & > .eventText {
        position: absolute;
        bottom: ${isEvent ? "33px" : "2px"};
        left: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
        /* width: 88px;
        height: 58px; */
    }
    & > .eventDateText {
        position: absolute;
        top: -15px;
        right: 14px;
    }
    ${isEvent && {
        paddingBottom: "44px",
    }};
`;

const cardContentsStyle = css`
    width: 100%;
    box-sizing: border-box;
    position: relative;
    padding: 14px;
`;

const titleWrapStyle = css`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
`;
const titleStyle = css`
    display: flex;

    flex-direction: column;

    overflow: hidden;
    color: #0c002c;
    text-overflow: ellipsis;
    font-size: 16px;
    line-height: 26px; /* 162.5% */

    .priceDiscountDisplay1 {
        font-size: 12px;
        color: #ff0000;
    }
`;

const eventImgBox = css`
    position: absolute;
    width: 120px;
    top: 100%;
    left: 20px;
`;

const bottomContent = css`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .stickerContainer {
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: flex-start;
        width: 100px;

        .discountRedText {
            min-width: 48px;
            width: 48px;
            height: 48px;
            background-color: #ff0000;
            color: #fff;
            font-size: 14px;
            font-weight: 400;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-weight: 700;
            line-height: 1.3;
        }
    }
`;

const priceWrapStyle = css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    box-sizing: border-box;
    /* width: 45%; */
`;

const term1PriceStyle = (hasMonthlyInstallmentEvent: boolean) => css`
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    .priceText {
        color: #3c3c3c;
        font-size: 18px;
        font-weight: 800;
        line-height: 26px;
        padding: 4px;
        background-color: #7bfd80;

        ${hasMonthlyInstallmentEvent && {
            textDecoration: "line-through",
            color: "#3c3c3c",
        }};
    }
`;

const term2PriceStyle = css`
    color: #8d8d8d;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px; /* 185.714% */
    display: flex;
    align-items: center;
    gap: 4px;
`;

const discountTextStyle = css`
    color: #0047ff;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
`;

const lastDiscountTextStyle = css`
    border-radius: 100px;
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: red;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    min-width: 36px;
`;

const priceInfoStyle = css`
    color: #3c3c3c;
    text-align: right;
    font-size: 10px;
    font-weight: 400;
    line-height: 26px; /* 162.5% */
    text-decoration: line-through;
    text-decoration-line: strikethrough;
`;

const monthlyStyle = css`
    display: flex;
    flex-direction: column;
    margin-top: -10px;
    img {
        display: block;
        position: relative;
        left: 43%;
    }
    span {
        color: red;
        font-weight: 800;
        font-size: 18px;
        line-height: 1.6;
    }
`;

const discountPriceTextStyle = css`
    color: #8d8d8d;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    text-decoration: line-through;
    text-decoration-line: strikethrough;
`;

const eventBoxStyle = css`
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #fff500;
    border-radius: 0 0 14px 14px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    .lottie {
        height: 40px;
        width: 40px;
    }
`;

const monthlyInstallmentArrowStyle = css`
    position: absolute;
    left: -22px;
    top: 40%;
`;

const monthlyInstallmentPriceStyle = css`
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: 22px;
    white-space: nowrap;

    color: #ff0000;
`;

const timerStyle = css`
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff500;
    font-size: 14px;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;

    .lottie {
        height: 30px;
        width: 30px;
    }
`;
